export default __webpack_public_path__ + "static/github-dark-9d7b0e5e03cbf3f7c5fcea4691053051.png";